import React from 'react';
import { withStyles } from 'tss-react/mui';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

const styles = theme => ({
  formControl: {
    margin: theme.spacing(1),
    width: '100%'
  },
  group: {
    margin: `${theme.spacing(1)} 0`,
    flexDirection: 'row',
    justifyContent: 'center'
  },
});

const Causes = React.memo(({
  value,
  handleChange,
  classes,
  fetchData,
  isPris,
  useMauvaisAlias
}) => (
  <FormControl component="fieldset" className={classes.formControl}>
    <RadioGroup
      className={classes.group}
      value={value ? value.toString() : ''}
      onChange={handleChange} >
      {fetchData.map((e) => (
        <FormControlLabel
          key={`${e._id.toString()}-${e.name}`}
          disabled={!isPris && e.disable}
          value={e._id.toString()}
          control={<Radio />}
          label={
            useMauvaisAlias && e.mauvaisAlias
              ? e.mauvaisAlias
              : e.name
          }
        />
      ))}
    </RadioGroup>
  </FormControl>));

export default withStyles(Causes, styles);
